import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { Button } from '../../../components/buttons/buttons';

const AiDraftConfirmPopup = ({ open, onCancel, onConfirm }) => {
  return (
    <Modal
      title="Confirm Action"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      footer={[
        <div>
          <Button htmlType="button" size="small" className="gray-button" onClick={onCancel}>
            <FeatherIcon icon="x" /> Cancel
          </Button>
          <Button htmlType="button" size="small" onClick={onConfirm} className="button_colors">
            <FeatherIcon icon="send" /> Send Anyway
          </Button>
        </div>
      ]}
    >
      <div style={{ padding: "0px 20px" }}>
        <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
          <p>Are you sure you want to send this email without inserting the AI draft?</p>
        </div>
      </div>
    </Modal>
  );
};

AiDraftConfirmPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default AiDraftConfirmPopup;
